import { useState } from 'react';
import { ThemeContext } from '../../../constants/themes';
import Loader from '../../atoms/Loader';
import Type from '../../atoms/Type';
import Parrot from '../../../api/parrot';
import './index.css';

const parrot = new Parrot();

const FileUpload = ({ id, getToken }) => {
  const [state, setState] = useState({
    isUploading: false,
    isComplete: false
  });

  const postFile = async (e) => {
    setState({
      ...state,
      isUploading: true
    });
    const file = e.target.files[0];
    const accessToken = await getToken();
    parrot.postRecording(accessToken, id, file).then(res => {
      console.log(res);
      setState({
        ...state,
        isUploading: false,
        isComplete: true
      })
    });
  }

  return (
    <ThemeContext.Consumer>
        {themeContext => (
          <div className="file-upload-wrapper">
            {state.isComplete ?
              <>
                <Type>Uploaded!</Type>
              </>
              :
              (state.isUploading ?
                <>
                  <Type>Uploading...</Type>
                  <Loader />
                </>
                :
                <label class="file-upload-input-box" style={{color: themeContext.theme.body, backgroundColor: themeContext.theme.text}}>
                  <input className="file-upload-input" type="file" id="file" name="file" accept="audio/*" onChange={postFile} />
                  Upload .mp3 or .m4a file
                </label>
              )
            }
          </div>
        )}
      </ThemeContext.Consumer>
  );
};

export default FileUpload;